import React, { memo, useState } from 'react';
import { Stack, ToggleButtonGroup, ToggleButton } from 'investira.react.components';
const Controls = memo(props => {
  const { range = {} } = props;
  const [rangeSelected, setRangeSelected] = useState(range.selected);
  function handleSetRange(pType, pCount, pIndex) {
    range.setRange(pType, pCount, pIndex);
    setRangeSelected(pIndex);
  }
  return (
    <Stack
      marginTop={{
        xs: 2,
        md: 0
      }}
      spacing={2}
      direction={{
        xs: 'column',
        md: 'row'
      }}
      alignItems={{
        md: 'center'
      }}
      flexGrow={1}
      width={'100%'}>
      <Stack
        spacing={2}
        direction={'row'}
        flexGrow={1}
        justifyContent={{
          xs: 'space-between',
          md: 'flex-end'
        }}
        alignItems={{
          xs: 'center'
        }}></Stack>
      <Stack spacing={2} direction="row">
        <ToggleButtonGroup value={rangeSelected} size="small" color="primary" fullWidth>
          {range.buttons.map((xOption, xIndex) => {
            return (
              <ToggleButton
                key={xOption.text}
                onClick={() => handleSetRange(xOption.type, xOption.count, xIndex)}
                value={xIndex}>
                {xOption.text}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  );
});
Controls.displayName = 'Controls';
export default Controls;
